(() => {
  function init(root) {
    if (root.dataset.ready) return;
    const search = root.querySelector('[data-faq-search]');
    const clear = root.querySelector('[data-faq-clear]');
    const status = root.querySelector('[data-faq-status]');
    const empty = root.querySelector('[data-faq-empty]');
    const groups = [...root.querySelectorAll('[data-faq-group]')];
    const questions = [...root.querySelectorAll('[data-faq-question]')];
    const normalize = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    const records = questions.map(question => ({
      question,
      text: normalize(question.querySelector('summary > span').textContent + ' ' + question.querySelector('.vg-faq-answer').textContent)
    }));
    let wasSearching = false;
    function update() {
      const terms = normalize(search.value).trim().split(/\s+/).filter(Boolean);
      const searching = terms.length > 0;
      let count = 0;
      records.forEach(({ question, text }) => {
        if (searching && !wasSearching) question.dataset.previousOpen = String(question.open);
        const match = terms.every(term => text.includes(term));
        question.hidden = !match;
        if (searching) question.open = match;
        else if (wasSearching) question.open = question.dataset.previousOpen === 'true';
        if (match) count++;
      });
      groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-faq-question]')].some(question => !question.hidden); });
      clear.hidden = !search.value;
      empty.hidden = count > 0;
      status.textContent = searching ? `${count} ${count === 1 ? 'answer' : 'answers'} found` : '';
      wasSearching = searching;
    }
    search.addEventListener('input', update);
    clear.addEventListener('click', () => { search.value = ''; update(); search.focus(); });
    search.addEventListener('keydown', event => {
      if (event.key === 'Escape') { search.value = ''; update(); }
    });
    root.querySelectorAll('[data-faq-topic]').forEach(link => {
      link.addEventListener('click', () => { search.value = ''; update(); });
    });
    root.dataset.ready = 'true';
    update();
  }
  document.querySelectorAll('[data-vg-faq]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vg-faq]').forEach(init));
})();
